import { Entity, MicroMClient } from "@mcurros2/microm";
import { IconBuildingCommunity } from "@tabler/icons-react";
import { EnviarRecibosDetallesProcesarDef } from "./EnviarRecibosDetallesProcesarDef";

export const EnviarRecibosDetallesProcesarHelpText = "* Enviar recibos.";
export const EnviarRecibosDetallesProcesarIcon = IconBuildingCommunity;

export class EnviarRecibosDetallesProcesar extends Entity<EnviarRecibosDetallesProcesarDef> {

    constructor(client: MicroMClient, parentKeys = {}) {
        super(client, new EnviarRecibosDetallesProcesarDef(), parentKeys);
        this.Form = import('./EnviarRecibosDetallesProcesarForm').then((module) => module.EnviarRecibosDetallesProcesarForm);
        this.Title = "Proceso de Envío de Recibos de Sueldo";
        this.HelpText = EnviarRecibosDetallesProcesarHelpText;
        this.Icon = EnviarRecibosDetallesProcesarIcon;
    }
}